import moment from 'moment';

// Locale Indonesia harus dimuat eksplisit — alias webpack memetakan moment
// langsung ke moment.js, sehingga tanpa ini hanya locale 'en' yang tersedia
// dan moment().locale('id') gagal senyap (waktu relatif tetap bahasa Inggris).
import 'moment/locale/id';

window.moment = moment;
